/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import Debounce from "../../../../CommonMethods/Debounce";
import { useCallback } from "react";
import { useDispatch ,useSelector} from "react-redux";
import { setMonitorCurIndex,toggleMonitorRowSelection,selectAllMonitorRows,addAllMonitorsInitially, fillEmptyMonitorArray, searchMonitorReducer} from "../../../ManageOrganizations/monitorsSlice";
import { dataService } from "../../../../services/data.services";
import { useContext } from "react";
import GlobalContext from "../../../../components/Context/GloablContext";
import { resetMonitorArray } from "../../../ManageOrganizations/monitorsSlice";

export default function MonitorsDropdownwithSearch({
    label,
    id,
    placeholder,
    value,
    disabled,
    index,
    data,
    isFetching,
    setMonitorDataList,
    selectedOrganizationId,
    selectedSubdivisionId,
    isMonitorsOpen,
    setIsMonitorsOpen,
    setMonitorDataLoading,
    setIsProviderAddOrDelete,
    setIsObserverAddOrDelete,
    monitorResult,
    setLinkOrganizationModel,
    noLabel
}
) {
    const { setToastmessage,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    const ref = useRef();
    const dispatch=useDispatch()
    const selectedUsers=useSelector(state=>state?.monitorsSelect?.selectedUsers)
    const curIndex=useSelector(state=>state?.monitorsSelect?.selectedUsers?.curIndex)
    const checkedArr= useSelector(state=>state?.monitorsSelect?.selectedUsers?.checkedArr)
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [suggestions,setSuggestions] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)


    function handleIsCheckedAll(event){
     
        dispatch(selectAllMonitorRows([event.target.checked,data?.data?.filter(item=>!monitorResult.includes(item.user_id))]))
    }
   

    // useOnClickOutside(ref, () => {
    //     setIsMonitorsOpen(false);
    // });

    
    
  
     
    const handleChange=async(val,orgId,subId)=>{
        if(val.trim()!==''){
            let endpoint=`patients/list-monitor-users?organization_id=${orgId}&subdivision_id=${subId}&search=${encodeURIComponent(val)}`
            try{
                setMonitorDataLoading(true)
                const response = await dataService.GetAPI(endpoint)
                setMonitorDataLoading(false)
                setMonitorDataList(response?.data?.data)
           
            }catch(error){
                setToastErrorMessage(error?.message)
                setMonitorDataLoading(false)
            }
           
        }
        else{
            let endpoint=`patients/list-monitor-users?organization_id=${orgId}&subdivision_id=${subId}`
            try{
                setMonitorDataLoading(true)
                const response = await dataService.GetAPI(endpoint)
                setMonitorDataLoading(false)
                setMonitorDataList(response?.data?.data)
           
            }catch(error){
                setToastErrorMessage(error?.message)
                setMonitorDataLoading(false)
            }
        }
        
    }
    const optimizedFn = useCallback(
        Debounce((value,selectedOrganizationId,selectedSubdivisionId) => handleChange(value,selectedOrganizationId,selectedSubdivisionId)),
        []
    );

    useEffect(()=>{
        isFetching?setDisplayEmptyMsg(''):''
    },[isFetching])

    useEffect(() => {
        if (data !== undefined) {
            // Dispatch searchReducer to manage state
            dispatch(searchMonitorReducer([data?.data, curIndex]));
        
            // Check if data exists and filter out any items already in monitorResult
            const filteredData = data?.data?.filter(item => !monitorResult?.includes(item?.user_id));
        
            // If filteredData is empty, show "No results found."
            if (filteredData?.length === 0) {
                setDisplayEmptyMsg('No results found.');
                return;
            }
        
            // If there are results, clear the empty message
            setDisplayEmptyMsg('');
        }
    }, [data, monitorResult, curIndex, dispatch]);

    const handleMonitorDropdownOpen=()=>{
        setIsMonitorsOpen(!isMonitorsOpen)
        dispatch(setMonitorCurIndex([index]))
        
        if((data?.data?.length===0&&!isFetching)||(!isFetching&&data?.data?.map(item=>item?.user_id)?.every((item)=>monitorResult?.includes(item)))){
            
            setDisplayEmptyMsg('No results found')
        }else{
            setDisplayEmptyMsg('')
        }
       
        suggestions!==""&&optimizedFn('',selectedOrganizationId,selectedSubdivisionId),setSuggestions('')
        
    }

  

    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button  ref={buttonRef} onClick={handleMonitorDropdownOpen} id="subdivision" className={`border 'border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between  disabled:bg-[#E7EAF4] items-center`} disabled={disabled}>
                    <p id= {id}className={`${(value === "" || value === undefined || value === true)?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isMonitorsOpen?"transform rotate-180" : ""}`}/>
                </button>
                {isMonitorsOpen&&<ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[999] absolute ${noLabel? "top-[48px]":"top-[72px]"} w-full left-0 border border-[#C5C9DA]`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input 
                                        type="text" 
                                        autoComplete={"off"}
                                        id="search-value-monitor"
                                        placeholder="Search by last name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none" 
                                        onChange={e=>{setSuggestions(e.target.value);optimizedFn(e.target.value,selectedOrganizationId,selectedSubdivisionId)}}
                                        value={suggestions}/>
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3"/>
                                </div>
                            </li>
                
                            {displayEmptyMsg==="" &&!(isFetching)&&data?.total_count!==0 ?<li className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1 pr-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='id1monitor' 
                                        checked={
                                            data?.data?.filter(item => !monitorResult?.includes(item.user_id)) // Filter out already selected providerResult
                                                .every(item => selectedUsers?.checkedArr[curIndex]?.includes(item.user_id)) // Check if all items are selected
                                        }

                                        onChange={(e)=>handleIsCheckedAll(e)} className='prevent-click' />
                                    <label htmlFor='id1monitor' data-testid='select_all' className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}>Select All</label>
                                </div>
                                <button onClick={()=>{dispatch(selectAllMonitorRows([false,data?.data]))}} type='button' className={selectedUsers?.checkedArr[0]?.length===0||(selectedUsers?.checkedArr?.[0].length===1&&selectedUsers?.checkedArr?.[0]?.[0]===null)?'hidden':`text-xs font-semibold text-[#008586]`}>
                                    Clear All
                                </button>
                            </li>:<p className="mt-2 text-center">{displayEmptyMsg}</p>}
                        </ul>
                        {((isFetching))? <div className=' h-[30px] relative   px-4 xl rounded-lg mt-3 '>
                            <div className='flex justify-center items-center mt-[90px]'>
                                                           
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                                                           
                                                            
                            </div>
                        </div>:data!==undefined&&!isFetching&&<ul>
                            <li>
                                <ul className={`max-h-[240px] overflow-auto scrollbar_gray pr-3 mb-2`}>
                                    {
                                        data?.data?.map((item,i)=>(
                                            !monitorResult?.includes(item?.user_id)&&<li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                    <input type="checkbox" id={i+"monitor_users"} onChange={()=>dispatch(toggleMonitorRowSelection([item?.user_id,data?.data?.filter(item=>!monitorResult?.includes(item.user_id))]))} checked={selectedUsers?.checkedArr[curIndex]?.includes(item?.user_id)?true:false} className=' prevent-click' />
                                                    <label title={item?.user_id} id={i+"monitor_user"} htmlFor={i+"monitor_users"} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"> {item?.last_name},{item?.first_name} {item?.user_id}</label>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                                {displayEmptyMsg===""&&!isFetching&&data?.total_count!==0&&<div className="flex justify-center">
                                    <button  
                                        onClick={()=>{setLinkOrganizationModel(true),setIsMonitorsOpen(false),setIsProviderAddOrDelete(false),setIsObserverAddOrDelete(false)}}
                                        type='button'
                                        id="Apply"
                                        disabled={selectedUsers?.checkedArr?.[0]?.length===0||(selectedUsers?.checkedArr?.[0].length===1&&selectedUsers?.checkedArr?.[0]?.[0]===null)}
                                        className={`py-2 w-[200px] px-2 rounded-[16px]  bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C] text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf disabled:bg-[#777C88] disabled:border-[#777C88]`}>
                                        Apply
                                    </button>
                                </div>}
                            </li>
                        </ul>}
                    </li>
                 
                </ul> }            
            </div>
        </>
    )
}
